import { Button } from '@mui/joy';
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined';

export function UnitsToggleButton({ value, onChange }) {
  return (
    <Button 
      size="sm" 
      variant="outlined" 
      color="neutral"
      onClick={() => onChange(!value)}
      startDecorator={<ScaleOutlinedIcon sx={{ fontSize: '14px' }} />}
      sx={{ width: '100px', fontSize: '12px' }}
    >
      {value ? 'Original' : 'Preferred'}
    </Button>
  );
}
